import React, { memo } from 'react';
import { Text, Image, View, Pressable, StyleSheet } from 'react-native';

import { FONT, FONT_SIZE, COLOR } from '../../../constants/styles';

const ContainerSuccess = (props) => {
  const successMessage = props.successMessage;
  const dismissMessage = props.dismissMessage;
  const notificationStyle = props.notificationStyle || 'success';
  return (
    <div
      style={{
        overflow: 'hidden',
        height: successMessage ? 50 : 0,
        transition: 'height 400ms ease-out',
      }}
    >
      <View
        style={[
          styles.successWrapper,
          notificationStyle === 'notification' ? styles.successWrapperNotification : null,
        ]}
      >
        {notificationStyle === 'success' && (
          <Image
            style={styles.checkIcon}
            source={require('../../../../resources/check-outline.svg')}
          />
        )}
        {!!props.onPress ? (
          <Pressable style={styles.messageButton} onPress={props.onPress}>
            <Text
              style={[
                styles.successMessage,
                notificationStyle === 'notification' ? styles.successMessageNotification : null,
              ]}
            >
              {successMessage || ''}
            </Text>
          </Pressable>
        ) : (
          <Text
            style={[
              styles.successMessage,
              notificationStyle === 'notification' ? styles.successMessageNotification : null,
            ]}
          >
            {successMessage || ''}
          </Text>
        )}
        {!!dismissMessage && (
          <Pressable
            style={styles.closeButton}
            onPress={() => {
              dismissMessage?.(notificationStyle);
            }}
          >
            <Image
              style={styles.checkIcon}
              source={require('../../../../resources/close-orange.png')}
            />
          </Pressable>
        )}
      </View>
    </div>
  );
};

export default memo(ContainerSuccess);

const styles = StyleSheet.create({
  successWrapper: {
    height: 50,
    width: '100%',
    flexDirection: 'row',
    backgroundColor: COLOR.success,
    paddingLeft: 20,
  },
  successWrapperNotification: {
    backgroundColor: COLOR.button,
    justifyContent: 'center',
  },
  checkIcon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
    marginVertical: 'auto',
    tintColor: COLOR.contrast,
  },
  messageButton: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  successMessage: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.small,
    color: COLOR.textReversed,
    paddingHorizontal: 20,
    marginLeft: 0,
    marginVertical: 'auto',
    flex: 1,
  },
  successMessageNotification: {
    textAlign: 'center',
  },
  closeButton: {
    paddingHorizontal: 20,
  },
});
